import { jsx } from 'react/jsx-runtime';
import { cva } from '../../vendor/class-variance-authority/dist/index.mjs';
import { forwardRef } from 'react';
import { cn } from '../../lib/utils.js';

const badgeVariants = cva(
  "badge inline-flex items-center rounded-full px-2 body-sm font-weight-medium transition-colors break-keep whitespace-nowrap",
  {
    variants: {
      variant: {
        soft: "rounded pt-[5px] pb-[3px]",
        draft: "h-[26px] px-[10px] py-1 focus-visible:outline-2 focus-visible:outline-offset-2",
        circle: "w-[6px] h-[6px] p-0"
      },
      color: {
        blue: "bg-blue-600 text-base-white [&_*]:text-base-white",
        red: "bg-state-danger-01 text-base-white [&_*]:text-base-white",
        grey: "bg-neutral-800",
        purple: "bg-[#8b0fed]",
        green: "bg-[#38d200]",
        orange: "bg-[#f0810d]",
        success: "bg-state-positive-02 text-state-positive [&_*]:text-state-positive",
        information: "bg-state-informative-02 text-primary-04 [&_*]:text-primary-04",
        neutral: "bg-state-pending-02 text-state-pending [&_*]:text-state-pending",
        warning: "bg-state-danger-02 text-state-danger [&_*]:text-state-danger",
        yellow: "bg-extra-04 text-basic-02 [&_*]:text-basic-02",
        teal: "bg-extra-03 text-basic-02 [&_*]:text-basic-02",
        gold: "bg-extra-01 text-extra-01 [&_*]:text-extra-01",
        lightPurple: "bg-icon-extra-02 text-extra-02 [&_*]:text-extra-02",
        lightyellow: "bg-extra-01 text-extra-01 [&_*]:text-extra-01",
        lavender: "bg-extra-02 text-extra-02 [&_*]:text-extra-02"
      }
    },
    defaultVariants: {
      variant: "soft"
    }
  }
);
const Badge = forwardRef(
  ({ className, variant, color, circleSize, circleLine, onClick, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref,
        tabIndex: -1,
        className: cn(
          badgeVariants({ variant, color }),
          variant === "circle" && circleSize === "sm" && "w-[6px] h-[6px]",
          variant === "circle" && circleSize === "md" && "w-[8px] h-[8px]",
          variant === "circle" && circleSize === "lg" && "w-[10px] h-[10px]",
          variant === "circle" && circleLine && "border border-basic-06",
          className
        ),
        onClick,
        ...props,
        children: /* @__PURE__ */ jsx("span", { className: cn(variant === "circle" && "hidden"), children: props.children })
      }
    );
  }
);
Badge.displayName = "Badge";

export { Badge, badgeVariants };
